export const FOOTER_DATA_GA = {
  event: 'footer',
} as const;

export const FOOTER_DATA_TEST = {
  footer: 'footer',
  buyingTools: 'footer-buying-tools',
  buyingToolLink: 'footer-buying-tools-link',
  contact: 'footer-communication-channels',
  contactLink: 'footer-communication-channels-link-',
  nav: 'footer-nav',
  navLink: 'footer-nav-link',
} as const;
